import { render, staticRenderFns } from "./tempMomentsComponent.vue?vue&type=template&id=fda75654&scoped=true"
import script from "./tempMomentsComponent.vue?vue&type=script&lang=js"
export * from "./tempMomentsComponent.vue?vue&type=script&lang=js"
import style0 from "./tempMomentsComponent.vue?vue&type=style&index=0&id=fda75654&prod&scoped=true&lang=css"
import style1 from "./tempMomentsComponent.vue?vue&type=style&index=1&id=fda75654&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda75654",
  null
  
)

export default component.exports